<div [formGroup]="form" *ngIf="formField.scope === 'GLOBAL' || formField.real === false">
    <label [matTooltip]="formField.description">{{ formField.name }} <span
        style="color: red; position: relative; top: 3px;"
        *ngIf="formField.required">*</span></label>
    <div class="flex-100" >
        <div *ngIf="formField.type === 'TEXT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
                       (focusout)="formField.tag === 'TAG' ? findTagExists() : null" class="flex-100"
                >
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'NUM'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'number'"
                       (focusout)="numberValidation(formField.jsonProperty)" class="flex-100"
                >
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'BOOL'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
                    <mat-option *ngFor="let option of formField.options"
                                [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'TEXTAREA'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          [formControlName]="formField.jsonProperty" class="flex-100"

                >
                </textarea>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'SELECT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
                    <mat-option *ngFor="let option of formField.options"
                                [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'MULTI_SELECT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty"
                            multiple class="flex-100">
                    <mat-option *ngFor="let option of formField.options as Array"
                                [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.type === 'IMAGE'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
                       (focusout)="imageValidation(formField.jsonProperty)" class="flex-100"
                >
            </mat-form-field>
        </div>
    </div>
    <div class="action-buttons-container">
        <emm-language-global-icon
            *ngIf="formField.showLocaleIcons !== false && !formField.metadata?.localeSupport"
            (click)="editLocale()"
        ></emm-language-global-icon>
        <emm-language-dialog-icon
            *ngIf="formField.showLocaleIcons !== false && formField.metadata?.localeSupport"
            (click)="editLocale()"
        ></emm-language-dialog-icon>
    </div>
</div>

<div [formGroup]="form" *ngIf="(formField.scope !== 'GLOBAL' && formField.scope !== 'LOCAL') && formField?.metadata?.type">
    <label [matTooltip]="formField.description">{{ formField.name }} <span
        style="color: red; position: relative; top: 3px;"
        *ngIf="formField.metadata.required">*</span>
    </label>
    <div class="flex-100" >
        <div *ngIf="formField.metadata.type === 'TEXT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
                       (focusout)="formField.tag === 'TAG' ? findTagExists() : null" class="flex-100"
                >
            </mat-form-field>
        </div>

        <div *ngIf="formField.metadata.type === 'NUM'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'number'"
                       (focusout)="numberValidation(formField.jsonProperty)" class="flex-100"
                >
            </mat-form-field>
        </div>

        <div *ngIf="formField.metadata.type === 'BOOL'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
                    <mat-option *ngFor="let option of formField.metadata.options"
                                [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.metadata.type === 'TEXTAREA'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          [formControlName]="formField.jsonProperty" class="flex-100"

                >
                </textarea>
            </mat-form-field>
        </div>

        <div *ngIf="formField.metadata.type === 'SELECT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
                    <mat-option *ngFor="let option of formField.metadata.options"
                                [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.metadata.type === 'MULTI_SELECT'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <mat-select [formControlName]="formField.jsonProperty"  multiple class="flex-100">
                    <mat-option *ngFor="let option of formField.metadata.options as Array"
                                [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="formField.metadata.type === 'IMAGE'" [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
            <mat-form-field appearance="fill"   class="flex-align-center flex-100">
                <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
                       (focusout)="imageValidation(formField.jsonProperty)" class="flex-100"
                >
            </mat-form-field>
        </div>
    </div>
    <div class="action-buttons-container">
        <emm-language-global-icon
            *ngIf="formField.showLocaleIcons !== false && !formField.metadata.localeSupport"
            (click)="editLocale()"
        ></emm-language-global-icon>
        <emm-language-dialog-icon
            *ngIf="formField.showLocaleIcons !== false && formField.metadata.localeSupport"
            (click)="editLocale()"
        ></emm-language-dialog-icon>
    </div>
</div>
